import Dashboard from "layouts/dashboard";
import Category from "layouts/category";
import Products from "layouts/products";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import Icon from "@mui/material/Icon";
import Warehouse from "layouts/warehouse";
import Brand from "layouts/brand";
import Filters from "layouts/filters";
import Sell from "layouts/sell";
import Buy from "layouts/buy";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize='small'>dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "users",
  //   icon: <Icon fontSize='small'>person</Icon>,
  //   route: "/users",
  //   component: <Users />,
  // },
  {
    type: "collapse",
    name: "Category",
    key: "category",
    icon: <Icon fontSize='small'>category</Icon>,
    route: "/category",
    component: <Category />,
  },
  {
    type: "collapse",
    name: "Filters",
    key: "filter",
    icon: <Icon fontSize='small'>F</Icon>,
    route: "/filters",
    component: <Filters />,
  },
  {
    type: "collapse",
    name: "Brand",
    key: "brand",
    icon: <Icon fontSize='small'>apartment</Icon>,
    route: "/brand",
    component: <Brand />,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize='small'>P</Icon>,
    route: "/products",
    component: <Products />,
  },
  {
    type: "collapse",
    name: "Buy Leads",
    key: "buy",
    icon: <Icon fontSize='small'>B</Icon>,
    route: "/buy",
    component: <Buy />,
  },
  {
    type: "collapse",
    name: "Sell Leads",
    key: "sell",
    icon: <Icon fontSize='small'>sell</Icon>,
    route: "/sell",
    component: <Sell />,
  },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Orders",
  //   key: "orders",
  //   icon: <Icon fontSize='small'>receipt_long</Icon>,
  //   route: "/orders",
  //   component: <Orders />,
  // },
  // {
  //   type: "collapse",
  //   name: "Custom Battery",
  //   key: "custom_battery",
  //   icon: <Icon fontSize='small'>reorderRounded</Icon>,
  //   route: "/custom-battery",
  //   component: <CustomQueries />,
  // },
  // {
  //   type: "collapse",
  //   name: "Promo Code",
  //   key: "promo_code",
  //   icon: <Icon fontSize='small'>passwordOutlinedIcon</Icon>,
  //   route: "/promo-code",
  //   component: <PromoCode />,
  // },
  // {
  //   type: "collapse",
  //   name: "Warehouse",
  //   key: "warehouse",
  //   icon: <Icon fontSize='small'>warehouse</Icon>,
  //   route: "/warehouse",
  //   component: <Warehouse />,
  // },
  // {
  //   type: "collapse",
  //   name: "Test",
  //   key: "test",
  //   icon: <Icon fontSize='small'>receipt_long</Icon>,
  //   route: "/test",
  //   component: <Test />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "title",
    title: "Logout",
    key: "logout",
    icon: <Icon fontSize='small'>logout</Icon>,
    route: "",
    component: "",
  },
  // {
  //   type: "collapse",
  //   name: "Product Details",
  //   key: "product-details",
  //   icon: <Icon fontSize='small'>login</Icon>,
  //   route: "/product-details",
  //   component: <ProductDetailPage />,
  // },
  // {
  //   type: "collapse",
  //   name: "Product Detail",
  //   key: "product-detail",
  //   icon: <Icon fontSize='small'>login</Icon>,
  //   route: "/product-detail",
  //   component: <ProductDetail />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize='small'>assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
